<template>
    <nav id="topnav" class="navbar navbar-expand bg-light sticky-top">
        <div class="container-fluid">
            <a :href="clientConfig.clientUrl"><img :src="clientConfig.clientLogo" alt="Logo" height="36"
                    class="d-inline-block align-text-top logo ps-1" /></a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse ps-3" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <a class="nav-link active" aria-current="page" href="/">Home</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/rules">Rules</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/data">Data</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/contactus">Contact Us</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/faq">FAQ</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/LearningModule">Learning Module</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/SectionContent/ReleaseNotes">Release Notes</a>
                    </li>
                </ul>
                <div class="d-flex" role="search">
                    <input class="form-control me-2" type="text" placeholder="Search" aria-label="Search"
                        v-model="searchString" @keyup.enter="searchFor(searchString)" />
                    <button class="btn btn-secondary" type="button" @click="searchFor(searchString)">Search</button>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import GDOTLogo from "/public/gdot-logo.png";

export default {
    data() {
        return {
            clientConfig: {
                clientUrl: "/",
                clientLogo: GDOTLogo,
            },
            searchString: ""
        };
    },
    methods:
    {
        searchFor(searchString) {
            this.$router.push({
                path: '/search',
                query: { q: searchString }
            }).catch(e => gotCaught(e))
        }
    }
};
</script>

<style>
#topnav {
    -webkit-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
    -moz-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
    -ms-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
    -o-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
}

/* remove nav element when printed */
@media print {
    #topnav {
        display: none !important;
    }
}
</style>
